import React from 'react';
import Grid from '@mui/material/Grid2';
import {
  FilterControl,
  FilterSelect,
  FilterTextInput,
} from '../../../common/table/filter-controls';
import TableResultsSummary from '../../../common/table/table-results-summary';
import { FILTER_GRID } from '../domain/table-hac.constants';
import {
  getCountryOptions,
  getRetailerSelectOptions,
} from '../domain/table-hac.utils';

const getPmaTypeOptions = (t) => [
  { value: '1', label: t('common-primary') },
  { value: '2', label: t('common-secondary') },
];

function TableHacFilters({
  t,
  filters,
  countries,
  retailers,
  // showPmaFilter = false, // TODO(PMAGM-pma-filter): enable once backend is ready
  // pmas = [], // TODO(PMAGM-pma-filter): enable once backend is ready
  resultCount,
  showSummary = true,
  onFilterChange,
  onApply,
  onReset,
}) {
  // const pmaOptions = pmas.map((pma) => ({ value: pma.id, label: `${pma.name} ${pma.last_name}` })); // TODO(PMAGM-pma-filter)

  return (
    <div className="filters">
      <p>{t('common-search')}</p>

      <Grid container spacing={3} rowSpacing={0}>
        <Grid size={FILTER_GRID.name}>
          <FilterControl id="name" label={`${t('common-name')}/${t('common-last-name')}`}>
            <FilterTextInput
              id="name"
              value={filters.name}
              onChange={onFilterChange}
            />
          </FilterControl>
        </Grid>

        <Grid size={FILTER_GRID.standard}>
          <FilterControl id="phone" label={t('common-phone')}>
            <FilterTextInput
              id="phone"
              value={filters.phone}
              onChange={onFilterChange}
            />
          </FilterControl>
        </Grid>

        <Grid size={FILTER_GRID.standard}>
          <FilterControl id="country" label={t('common-country')}>
            <FilterSelect
              id="country"
              value={filters.country || ''}
              onChange={onFilterChange}
              options={getCountryOptions(countries, t)}
              allLabel={t('common-all-country')}
            />
          </FilterControl>
        </Grid>

        <Grid size={FILTER_GRID.standard}>
          <FilterControl id="pma_type" label={t('common-assigned-as')}>
            <FilterSelect
              id="pma_type"
              value={filters.pma_type}
              onChange={onFilterChange}
              options={getPmaTypeOptions(t)}
              allLabel={t('common-all-types')}
            />
          </FilterControl>
        </Grid>

        <Grid size={FILTER_GRID.retailer}>
          <FilterControl id="retailer" label={t('common-retailer')}>
            <FilterSelect
              id="retailer"
              value={filters.retailer}
              onChange={onFilterChange}
              options={getRetailerSelectOptions(retailers)}
              allLabel={t('common-all-retailers')}
            />
          </FilterControl>
        </Grid>

        {/* TODO(PMAGM-pma-filter): enable once backend returns the PMAGM's team
        {showPmaFilter && (
          <Grid size={FILTER_GRID.standard}>
            <FilterControl id="pma" label={t('common-role-pma')}>
              <FilterSelect
                id="pma"
                value={filters.pma}
                onChange={onFilterChange}
                options={pmaOptions}
                allLabel={t('common-all-pma')}
              />
            </FilterControl>
          </Grid>
        )}
        */}
      </Grid>

      {showSummary && (
        <TableResultsSummary count={resultCount} />
      )}

      <Grid container spacing={3}>
        <Grid size={FILTER_GRID.action}>
          <div className="actions">
            <button className="btn" onClick={onApply}>
              {t('common-apply')}
            </button>
          </div>
        </Grid>

        <Grid size={FILTER_GRID.reset}>
          <div className="actions">
            <button onClick={onReset} className="btn text narrow">
              {t('common-reset-filters')}
            </button>
          </div>
        </Grid>
      </Grid>

    </div>
  );
}

export default TableHacFilters;
